import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@src/lib/ui/AlertDialog";
import { Button } from "@src/lib/ui/Button";
import { FC } from "react";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => Promise<void>;
};

export const DeleteHrisIntegrationDialog: FC<Props> = ({
  open,
  onOpenChange,
  onDelete,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete HRIS Integration</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>
              <div className="mb-3">
                Are you sure you want to delete this HRIS integration? This
                action cannot be undone.
              </div>
              <div>
                This is a destructive action that will prevent HRIS syncs from
                happening from this integration going forward.
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onDelete}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
